import { validateSchema } from '../../../../../../../helpers';
import { BAYS } from '../../../../../../../constants';
import {
  FullTPRecommendationSchema,
  LimitedTPRecommendationSchema,
} from '../../../utils/validationSchema';
import { LIST_OF_KEYS } from '../constants/general';

import type { IRecommendation, Bays } from '../../../../../../../utils/types';

export function getRecommendationSchemaForBay(tpBay: Bays) {
  return tpBay === BAYS.BAY_2_5 ? LimitedTPRecommendationSchema : FullTPRecommendationSchema;
}

export function getRecommendationFieldErrors(
  recommendation: IRecommendation | null,
  schema: ReturnType<typeof getRecommendationSchemaForBay>,
) {
  if (!recommendation || Object.keys(recommendation).length === 0) {
    return {};
  }
  const next: Record<string, boolean> = {};
  LIST_OF_KEYS.forEach((key) => {
    const isValid = validateSchema(schema, key, recommendation);
    next[key] = !isValid;
  });
  return next;
}
